import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { FilesInterceptor } from '@nestjs/platform-express';
import { ApiConsumes, ApiHeader, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { imageFileFilter } from '../shared/file-upload';
import { EditLivetvDTO, livetvActiveDTO, LivetvDTO, livetvStatusDTO } from './dto/livetv.dto';
import { livetvResponseModel, AlllivetvResponseModel, livetvstatusResponseModel } from './livetv-response-module';
import { LivetvService } from './livetv.service';
import { diskStorage } from 'multer';
import { extname } from 'path';

@ApiTags('livetv')
@Controller('livetv')
export class LivetvController {

    constructor (
        private LivetvService:LivetvService
    ) {}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/create')
    @ApiQuery({name:'apiVersion'})
    @UseInterceptors(
		FilesInterceptor('thumbnailImg', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/TVThumbnails',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async createlivetv(@Query() queryParams, @UploadedFiles() thumbnailImg, @Body() LivetvDTO:LivetvDTO, @Req() request: Request): Promise<livetvResponseModel> {
        try {
            const response = [];
            thumbnailImg.forEach(file => {
                console.log("fil");
                const fileReponse = {
                    livetvThumbnail: `livetv/TVThumbnails/${file.filename}`,                               
                };
               response.push(fileReponse);
            })
            return await this.LivetvService.createlivetv(queryParams, LivetvDTO, response, request);
        } catch (error) {
            return errorHandler(livetvResponseModel, error);
        }
    }

    /* @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/update')
    @ApiQuery({name:'apiVersion'})
    @UseInterceptors(
		FilesInterceptor('thumbnailImg', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/TVThumbnails',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async updatelivetv(@Query() queryParams, @UploadedFiles() thumbnailImg, @Body() LivetvDTO:LivetvDTO, @Req() request: Request): Promise<livetvResponseModel> {
        try {
            const response = [];
            var changeImg = false;
            thumbnailImg.forEach(file => {
                const fileReponse = {
                    livetvThumbnail: `livetv/TVThumbnails/${file.filename}`,                               
                };
                var changeImg = true;
               response.push(fileReponse);
            })
            return await this.LivetvService.updatelivetv(queryParams, LivetvDTO, response,changeImg, request);
        } catch (error) {
            return errorHandler(livetvResponseModel, error);
        }
    } */

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/update')
    @ApiQuery({name:'apiVersion'})
    async updatelivetv(@Query() queryParams, @Body() LivetvDTO:EditLivetvDTO, @Req() request: Request): Promise<livetvResponseModel> {
        try {
            return await this.LivetvService.updatelivetv(queryParams, LivetvDTO, request);
        } catch (error) {
            return errorHandler(livetvResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/activeLivetv')
    @ApiQuery({name:'apiVersion'})
    async activeLivetv(@Query() queryParams, @Body() livetvActiveDTO:livetvActiveDTO, @Req() request: Request): Promise<livetvResponseModel> {
        try {
            return await this.LivetvService.activeLivetv(queryParams, livetvActiveDTO, request);
        } catch (error) {
            return errorHandler(livetvResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getlivetv/:roleId')
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'roleId'})
    async getlivetv(@Query() queryParams,@Param('roleId') roleId, @Req() request:Request): Promise<AlllivetvResponseModel> {
        try {
            return await this.LivetvService.getlivetv(queryParams, roleId,request);
        } catch (error) {
            return errorHandler(AlllivetvResponseModel, error);
        }
    }    
    
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updatelivetvStatus')
    @ApiQuery({name:'apiVersion'})
    async updatelivetvStatus(@Query() queryParams, @Body() livetvStatusDTO:livetvStatusDTO, @Req() request: Request): Promise<livetvstatusResponseModel> {
        try {
            return await this.LivetvService.updatelivetvStatus(queryParams, livetvStatusDTO, request);
        } catch (error) {
            return errorHandler(livetvstatusResponseModel, error);
        }
    }

    @Get('/getLiveTvById/:Id')
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'Id'})
    async getLiveTvById(@Query() queryParams,@Param('Id') Id, @Req() request:Request):Promise<livetvResponseModel> {
		try {
			return await this.LivetvService.getLiveTvById(queryParams,Id,request);
		} catch (error) {
			return errorHandler(livetvResponseModel, error);
		}
    }

    @Get('/TVThumbnails/:imgpath')
    @ApiParam({name:'imgpath'})
    async seeUploadedPrifilePic(@Param('imgpath') Image, @Res() res) {
		try {
			return res.sendFile(Image, { root: './public/TVThumbnails' });
		} catch (error) {
			return error.message;
		}
    }

}
